import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore';
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import 'firebase/auth'
import 'firebase/firestore'

const firebaseConfig = {
    apiKey: "AIzaSyDUr2aCTrbmQJ7uEDpDT2DgruBUTPfae38",
    authDomain: "b2t-shop.firebaseapp.com",
    projectId: "b2t-shop",
    storageBucket: "b2t-shop.firebasestorage.app",
    messagingSenderId: "144720253857",
    appId: "1:144720253857:web:f3d6204fa05884cd08b1e0",
    measurementId: "G-FC3KW1YMZE"
};


const firebaseApp = initializeApp(firebaseConfig)

const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp)

export { firebaseApp, auth, db, signInWithEmailAndPassword };
